import { useRef, useEffect, useCallback } from 'react';

// Simple debounced callback that supports per-key timers (for multiple fields)
export default function useDebouncedCallback(delayMs = 500) {
  const timersRef = useRef({});

  useEffect(() => () => {
    // cleanup all timers on unmount
    Object.values(timersRef.current).forEach(clearTimeout);
    timersRef.current = {};
  }, []);

  const schedule = useCallback((key, fn) => {
    if (!key) return;
    if (timersRef.current[key]) clearTimeout(timersRef.current[key]);
    timersRef.current[key] = setTimeout(() => {
      delete timersRef.current[key];
      try { fn(); } catch (_) {}
    }, delayMs);
  }, [delayMs]);

  const cancel = useCallback((key) => {
    if (timersRef.current[key]) {
      clearTimeout(timersRef.current[key]);
      delete timersRef.current[key];
    }
  }, []);

  const flush = useCallback(async (key, fn) => {
    if (timersRef.current[key]) {
      clearTimeout(timersRef.current[key]);
      delete timersRef.current[key];
    }
    await fn();
  }, []);

  return { schedule, cancel, flush };
}


